import { useRecoilState } from "recoil"
import styled from "styled-components"
import { isMenuExpandedState } from "../../../recoil/common/Header"
import { BsList } from "react-icons/bs"
import { BsXLg } from "react-icons/bs"

const MenuToggleButton = () => {
  const [isMenuExpanded, setIsMenuExpanded] =
    useRecoilState(isMenuExpandedState)

  return (
    <ButtonContainer>
      <ToggleButton onClick={() => setIsMenuExpanded((prev) => !prev)}>
        {isMenuExpanded ? <BsXLg /> : <BsList />}
      </ToggleButton>
    </ButtonContainer>
  )
}

export default MenuToggleButton

const ButtonContainer = styled.div`
  width: 120px;
  height: 60px;
  text-align: start;
`

const ToggleButton = styled.div`
  margin-top: 15px;
  height: 30px;
  width: 30px;
  font-size: 30px;
  line-height: 30px;
`
